import React, { useState, useEffect } from 'react';
import { updatedata, getdata } from "../../util/global";

const defaultformdata = {
  instanceurl: '',
  accesstoken: '',
  clientid: '',
  clientsecret: '',
  leadcompany: 'Inbound Leads',
  leadstatus: 'Open - Not Contacted'
};

const SalesforceConfigForm = ({ showmodal, setshowmodal, phonenumber }) => {
  const [formdata, setformdata] = useState(defaultformdata);
  const [salesforceconfig, setsalesforceconfig] = useState({});
  
  const fetchdata = async () => {
    if (!phonenumber?._id) return;
    try {
      const sfdata = await getdata({ filter: { datatype: "salesforceconfigdata", _phonenumberid: phonenumber._id } });
      if (sfdata && sfdata.length > 0) {
        setsalesforceconfig(sfdata[0]);
      } else {
        setsalesforceconfig({ ...defaultformdata });
      }
      console.log("SF fetchdata called");
    } catch (err) { 
      console.error(err); 
    }
  };

  useEffect(() => {
    if (showmodal === "showsfconfig") {
      setformdata({ ...defaultformdata });
      setsalesforceconfig({});
      fetchdata();
    }
  }, [showmodal, phonenumber?._id]);
  
  useEffect(() => {
    if (salesforceconfig && Object.keys(salesforceconfig).length > 0) {
      setformdata({ ...defaultformdata, ...salesforceconfig });
    }
  }, [salesforceconfig]);

  const updatesalesforceconfig = async (sfconfig) => {
    sfconfig._phonenumberid = phonenumber._id;
    sfconfig.datatype = "salesforceconfigdata";
    await updatedata({ data: sfconfig });
    fetchdata();
  };

  if (showmodal !== "showsfconfig") return null;

  const saveconfig = async () => {
    $("#waitinggif").show();
    await updatesalesforceconfig(formdata);
    $("#waitinggif").hide();
    setshowmodal("");
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Salesforce API Configuration</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Instance URL (e.g. https://yourinstance.salesforce.com)</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.instanceurl || ''} 
              onChange={(e) => setformdata({...formdata, instanceurl: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Access Token (Bearer Token)</label>
            <textarea 
              className="form-input" 
              value={formdata.accesstoken || ''} 
              onChange={(e) => setformdata({...formdata, accesstoken: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Client ID (Connected App)</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.clientid || ''} 
              onChange={(e) => setformdata({...formdata, clientid: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Client Secret</label>
            <input 
              type="password" 
              className="form-input" 
              value={formdata.clientsecret || ''} 
              onChange={(e) => setformdata({...formdata, clientsecret: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Default Lead Company</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.leadcompany || ''} 
              onChange={(e) => setformdata({...formdata, leadcompany: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Default Lead Status</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.leadstatus || ''} 
              onChange={(e) => setformdata({...formdata, leadstatus: e.target.value})} 
            />              
          </div>

          <button className="btn-blue full-width" onClick={saveconfig}>
            Save <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px', position:'absolute'}} alt="saving"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesforceConfigForm;